<template>
    <div class="ui-detail">
        <!-- 详情区 -->
        <div class="detail-list">
            <a-row>
                <a-col :class="{'deep-bg' : calcDeepBg(i)}" :span="item.colSpan || 12" v-for="(item,i) in detailFields" :key="i">
                    <div class="detail-item clearfix" :class="{'disabled' : item.disabled}">

                        <div class="item-label fl">
                            <a-tooltip effect="dark" :content="item.label" placement="top">
                                <span>{{item.label}}：</span>
                            </a-tooltip>
                        </div>
                        <div class="item-detail fl">
                            <div class="item-detail-area" :class="{'has-unit' : item.unit}">
                                <template>
                                    <!-- 判空 -->
                                    <span v-if="!detailDatas[item.key] && detailDatas[item.key] !== 0 && detailDatas[item.key] !== '0'">--</span>
                                    <!-- 文本 -->
                                    <span v-else-if="!item.type || item.type == 'text'">{{ detailDatas[item.key] }}</span>
                                    <!-- 日期格式 -->
                                    <span v-else-if="item.type == 'date'">{{detailDatas[item.key]}}</span>
                                    <!-- 时间格式 -->
                                    <span v-else-if="item.type == 'time'">{{detailDatas[item.key]}}</span>
                                    <!-- 字典 -->
                                    <span v-else-if="item.type == 'dictionary'">{{detailDatas[item.key] | DictionaryFilter(item.dicKey,coInsNo)}}</span>
                                </template>
                            </div>
                            <div class="item-detail-unit" v-if="item.unit">
                                {{item.unit}}
                            </div>
                        </div>

                    </div>
                </a-col>
            </a-row>
        </div>

            
        <!-- 按钮区 -->
        <div class="btn-list" v-if="btnFields && btnFields.length > 0">
            <div class="default-btn btn-item" :class="`${item.cssType} ${item.disabled ? 'disabled' : ''}`"
            v-loading="item.loading"
            v-for="(item,i) in btnFields" :key="i"
            @click="btnClick(item)"
            >
                <i v-if="item.icon" :class="item.icon"></i>
                <span>{{item.label}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'UiDetail',
    props : {
        // 表单设置列表
        detailFields : {
            type : Array,
            default : () => []
        },
        // 按钮设置列表
        btnFields : {
            type : Array,
            default : () => []
        },
    },
    data () {
        return {
            coInsNo      : '',      // 当前查询的合作机构号
            detailDatas  : {},
        }
    },
    methods : {
        // @public()
        // 设置数据
        setData (tarDetailDatas) {
            this.detailDatas = tarDetailDatas;
        },
        // ------------------------------操作相关结束

        // 计算是否需要显示深色背景
        calcDeepBg (index) {
            // 当前元素之前的行元素，处于偶数行时，当前模块为深色模式
            let widthCount = 0;
            this.detailFields.map((item,i) => {
                if (i < index) widthCount += item.colSpan || 12;
            })
            if ( parseInt(widthCount / 24) % 2 === 0 ) return true;
            return false;
        },
        // 获取数据字典
        refreshDic (coInsNo) {
            this.coInsNo = coInsNo;
        },

        // 按钮点击事件
        btnClick (item) {
            item.run && item.run();
        },

    }
}
</script>

<style lang="less" scoped>
.ui-detail{
    // 表单区
    .detail-list{
        color:#666666;
        // border: 1px solid #EFEFEF;
        padding:20px;
        .a-col{
            border:1px solid #fff;
            &.deep-bg{
                background:#F9FAFD;
            }
            .detail-item{
                padding-bottom:8px;
                .item-label{
                    width:200px;
                    height:40px;
                    display:inline-block;
                    text-align: right;
                    line-height:40px;
                    padding-right:10px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    .red{
                        margin-right:5px;
                    }
                }
                .item-detail{
                    width:calc(100% - 200px);
                    height:40px;
                    line-height:40px;
                    display:inline-block;
                    position:relative;
                    padding-left:10px;
                    /deep/ .a-input.is-disabled .a-input__inner{
                        background:#EFEFEF;
                    }
                    // // detail输入区域
                    .item-detail-area{
                        display:inline-block;
                        & /deep/ div:first-child,/deep/ input{
                            // width:100%;
                            height:36px;
                            line-height:36px;
                            border:0;
                        }
                    }
                    // 单位
                    .item-detail-unit{
                        display:inline-block;
                        width:40px;
                        height:40px;
                        text-align: center;
                        line-height: 40px;
                    }
                    &.has-unit{
                        padding-right:40px;
                    }
                }
            }
        }
    }
}
</style>